// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from "projects/velocity/src/environments/IEnvironment";

export const environment: IEnvironment = {
  production: false,
  apiSource: '/api/',
  idle: 10 * 60,
  timeout: 60,
  ping: 30000,
  rootUrl: '',
  appUrl: '',
  clinicalCompetency_DebugMenu: true,
  patientScreens_UseUserFacilities: true,
  rollbarEnvironment: 'Development'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
